module.exports = __webpack_public_path__ + "img/aop.cc165397.png";